export const getters = {
  getSystemActions: state => state.systemactions
};

export default {};
